export const termsAndConditionsData = [
  {
    id: '1',
    title: 'Payments processed through MediPay',
    description:
      'All credit card transactions must be handled through MediPay as part of the bundled program.'
  },
  {
    id: '2',
    title: 'Onboarding provided under Good Faith Courtesy',
    description:
      'MediPay CC LLC covers setup and live onboarding, contingent on timely participation and compliance with MediPay terms.'
  },
  {
    id: '3',
    title: 'Myriad Health will not bill me directly',
    description:
      'Full software access is included at no cost while I maintain an active MediPay healthcare processing account.'
  },
  {
    id: '4',
    title: 'Participation in onboarding is required',
    description:
      ' I will attend trainings, meet deadlines, and supply necessary system data/credentials; Myriad Motion will assist with import and mapping.'
  },
  {
    id: '5',
    title: 'Risk of fees or suspension if terms are not followed',
    description:
      'Without MediPay processing (unless covered by a separate SaaS fee), I may incur minimum charges and risk suspension of EHR, billing, or payments.'
  },
  {
    id: '6',
    title: 'Compliance with all required agreements',
    description:
      'I will comply with applicable Terms/BAAs for Myriad-affiliated entities (including MediPay CC LLC, MedBill by Myriad LLC if applicable, and Myriad Health Software Order Terms).'
  },
  {
    id: '7',
    title: 'Myriad Systems terms of use',
    description: 'I acknowledge and agree to the Myriad Systems terms of use.',
    descriptionComponent: (
      <>
        I acknowledge and agree to the{' '}
        <a
          target="_blank"
          href="https://myriadsystems.ai/privacy-policy"
          className="text-neutral-900 !underline hover:text-neutral-500"
          rel="noreferrer">
          Myriad Systems terms of use
        </a>
        .
      </>
    )
  },
  {
    id: '8',
    title: 'MediPay service order terms & conditions',
    description: (
      <>
        I acknowledge and agree to the{' '}
        <a
          target="_blank"
          href="https://myriadsystems.ai/privacy-policy"
          className="text-neutral-900 !underline hover:text-neutral-500"
          rel="noreferrer">
          MediPay service order terms & conditions
        </a>
        .
      </>
    )
  }
];

export const responsibilitiesData = [
  {
    id: '1',
    title: 'Kickoff call',
    meetingKey: 'Kickoff live training',
    icon: 'responsibility-1',
    descriptionArray: [
      'Confirm setup',
      'Create test user (used during training by all users)',
      'Staff permissions',
      'Staff assignments',
      'Data ready / requested (if applicable)'
    ]
  },
  {
    id: '2',
    title: 'Front office training',
    meetingKey: 'Front office live training',
    icon: 'responsibility-2',
    descriptionArray: [
      'Healthcare Program education',
      'Healthcare Program setup (GFE + Pre-Authorized Healthcare)',
      'Test card reader + virtual terminal',
      'Upload Schedule of Fees',
      'Schedule test appointment',
      'Set up self-scheduling (if applicable)',
      'Watch product tour / video'
    ]
  },
  {
    id: '3',
    icon: 'responsibility-3',
    title: 'Clinical training',
    meetingKey: 'Clinical live training',
    descriptionArray: [
      'Forms & templates built (verified by principal user)',
      'Codes / products added (if 3D charting enabled; enables checkout flow)',
      'Watch product tour / video'
    ]
  },
  {
    id: '4',
    title: 'Billing training',
    meetingKey: 'Back office live training',
    icon: 'responsibility-4',
    descriptionArray: [
      'EDI enrollments submitted',
      'Verify Schedule of Fees & allowables (or acknowledge deferral)',
      'Full data import verified (principal user)',
      'File a test claim / send invoice',
      'Run a patient payment (card-on-file) (Pre-Authorized Healthcare form)',
      'Watch product tour / video'
    ]
  },
  {
    id: '5',
    title: 'Hard-go live',
    meetingKey: 'Hard launch live training',
    icon: 'responsibility-5',
    descriptionArray: ['100% onboarding & training complete', 'Live charting + patient payments']
  }
];
